import React, { useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import LinkModal from '../Movie/LinkModal'
import { CiLink } from 'react-icons/ci'
import Config from '../../Config/Config.json'
const ShortBioField = props => {
  // props for this file
  const {
    shortbio,
    error,
    shortbiote,
    handleShortbioteChange,
    handleShortbioChange,
    disableInput,
    setShortbio,
    setShortbiote,
    sendValuechangedBoolean,
  } = props
  const inputReferencedescriptionEn = useRef()
  const inputReferencedescriptionTe = useRef()
  const [modalOpen, setModalOpen] = useState(false)
  const [currentDescription, setCurrentDescription] = useState('')
  const [isTextSelectedEn, setIsTextSelectedEn] = useState(false)
  const [isTextSelectedTe, setIsTextSelectedTe] = useState(false)
  const [selectedText, setSelectedText] = useState('')
  const [link, setLink] = useState('')

  const handleButtonClick = description => {
    setCurrentDescription(description)
    setModalOpen(true)
  }

  const handleSaveLink = link => {
    const textarea =
      currentDescription === 'Bio'
        ? inputReferencedescriptionEn.current
        : inputReferencedescriptionTe.current

    if (textarea.selectionStart !== undefined && textarea.selectionEnd !== undefined) {
      const start = textarea.selectionStart
      const end = textarea.selectionEnd

      const selectedText =
        currentDescription === 'Bio'
          ? shortbio.substring(start, end)
          : shortbiote.substring(start, end)
      let updatedText = ''
      // if (selectedText) {
      //   let baseUrl = ''
      //   if (Config.Environment === 'Production') {
      //     // Production environment URL
      //     baseUrl = 'https://telugu.yousay.tv'
      //   } else if (Config.Environment === 'Development') {
      //     // Staging environment URL
      //     baseUrl = 'https://stagingyousay.ktree.org'
      //   } else {
      //     // Default URL for other environments
      //     baseUrl = 'https://stagingyousay.ktree.org'
      //   }

      //   if (link.includes(baseUrl)) {
      //     if (link.includes(`${baseUrl}/en/tfidb/`)) {
      //       updatedText =
      //         currentDescription === 'Bio'
      //           ? `${shortbio.substring(0, start)}<a href='${link.replace(
      //               `${baseUrl}/en/tfidb`,
      //               '',
      //             )}'>${selectedText}</a>${shortbio.substring(end)}`
      //           : `${shortbiote.substring(0, start)}<a href='${link.replace(
      //               `${baseUrl}/en/tfidb`,
      //               '',
      //             )}'>${selectedText}</a>${shortbiote.substring(end)}`
      //     } else {
      //       updatedText =
      //         currentDescription === 'Bio'
      //           ? `${shortbio.substring(0, start)}<a href='${link.replace(
      //               `${baseUrl}/tfidb`,
      //               '',
      //             )}'>${selectedText}</a>${shortbio.substring(end)}`
      //           : `${shortbiote.substring(0, start)}<a href='${link.replace(
      //               `${baseUrl}/tfidb`,
      //               '',
      //             )}'>${selectedText}</a>${shortbiote.substring(end)}`
      //     }
      //   } else {
      //     updatedText =
      //       currentDescription === 'Bio'
      //         ? `${shortbio.substring(
      //             0,
      //             start,
      //           )}<a href='${link}'>${selectedText}</a>${shortbio.substring(end)}`
      //         : `${shortbiote.substring(
      //             0,
      //             start,
      //           )}<a href='${link}'>${selectedText}</a>${shortbiote.substring(end)}`
      //   }
      // }
      if (selectedText) {
        let baseUrl = ''
        if (Config.Environment === 'Production') {
          baseUrl = 'https://telugu.yousay.tv'
        } else if (Config.Environment === 'Development') {
          baseUrl = 'https://stagingyousay.ktree.org'
        } else {
          baseUrl = 'https://stagingyousay.ktree.org'
        }

        if (link.includes(baseUrl)) {
          const path = link.includes(`${baseUrl}/en/tfidb/`)
            ? `${baseUrl}/en/tfidb`
            : `${baseUrl}/tfidb`

          updatedText =
            currentDescription === 'Bio'
              ? `${shortbio.substring(0, start)}<a href='${link.replace(
                  path,
                  '',
                )}'>${selectedText}</a>${shortbio.substring(end)}`
              : `${shortbiote.substring(0, start)}<a href='${link.replace(
                  path,
                  '',
                )}'>${selectedText}</a>${shortbiote.substring(end)}`
        } else {
          updatedText =
            currentDescription === 'Bio'
              ? `${shortbio.substring(
                  0,
                  start,
                )}<a href='${link}' target='_blank'>${selectedText}</a>${shortbio.substring(end)}`
              : `${shortbiote.substring(
                  0,
                  start,
                )}<a href='${link}' target='_blank'>${selectedText}</a>${shortbiote.substring(end)}`
        }
      }

      //  else {
      //   updatedText = `${
      //     currentDescription === 'description_En'
      //       ? movieAndOttNews
      //       : movieAndOttNewste
      //   }<a href='${link}'></a>`
      // }
      console.log(updatedText, 'updatedText')
      if (updatedText) {
        // (currentDescription === 'description_En' ? setMovieAndOttNews : setMovieAndOttNewste)(
        //   updatedText,
        // )
        if (currentDescription === 'Bio') {
          // updateInputData('Bio', updatedText)
          // sendtruevalue('Bio', true)
          setShortbio(updatedText)
          sendValuechangedBoolean('bio', true)
        } else {
          // updateInputData('biote', updatedText)
          // sendtruevalue('Biote', true)
          setShortbiote(updatedText)
          sendValuechangedBoolean('biote', true)
        }
      }
    }
  }

  const handleSelectionChange = (event, description) => {
    const textarea = event.target
    const { selectionStart } = textarea
    const { selectionEnd } = textarea

    // Update isTextSelected state based on whether text is selected
    // setIsTextSelected(selectionStart !== selectionEnd)
    if (description === 'Bio') {
      setIsTextSelectedEn(selectionStart !== selectionEnd)
    } else {
      setIsTextSelectedTe(selectionStart !== selectionEnd)
    }

    const selectedText = textarea.value.substring(selectionStart, selectionEnd).trim()
    setSelectedText(selectedText)
  }

  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <div className='shotbio'>
            <label>
              Short bio_En: <div className='mandatory'>*</div>
            </label>
            <div className='shortbio-spaceb'>
              {/* text area / input to enter bio in english */}
              <textarea
                type='text'
                name='shortbio'
                ref={inputReferencedescriptionEn}
                className='form-control'
                placeholder='Enter bio'
                value={shortbio}
                style={{ height: '250px' }}
                disabled={disableInput === true}
                // onchange sends changed value to handleShortbioteChange in another file
                onChange={handleShortbioChange}
                onSelect={event => handleSelectionChange(event, 'Bio')}
              />
            </div>
            {error.shortBio && (
              <div className='mandatory1'>
                <span>{error.shortBio}</span>
              </div>
            )}
            <button
              type='button'
              className='btn btn-primary'
              onClick={() => handleButtonClick('Bio')}
              disabled={!isTextSelectedEn}
            >
              <CiLink />
            </button>
          </div>
        </Col>
        <Col md={6} xs={12}>
          {/* displays only when shotbio is not empty */}
          {shortbio !== '' && (
            <div className='shotbio'>
              <label>
                Short bio_Te: <div className='mandatory'>*</div>
              </label>
              <div className='shortbio-te'>
                {/* text area / input to enter bio in Telugu */}
                <textarea
                  name='shortbiote'
                  type='text'
                  className='form-control'
                  ref={inputReferencedescriptionTe}
                  style={{ height: '250px' }}
                  disabled={disableInput === true}
                  // onchange sends changed value to handleShortbioteChange in another file
                  onChange={handleShortbioteChange}
                  value={shortbiote}
                  onSelect={event => handleSelectionChange(event, 'biote')}
                />
              </div>
              {error.shortBiote && (
                <div className='mandatory1'>
                  <span>{error.shortBiote}</span>
                </div>
              )}
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => handleButtonClick('biote')}
                disabled={!isTextSelectedTe}
              >
                <CiLink />
              </button>
            </div>
          )}
        </Col>
      </Row>
      {/* shows error if shotbio is not filled */}
      <LinkModal
        isOpen={modalOpen}
        selectedText={selectedText}
        link={link}
        setLink={setLink}
        onClose={() => {
          setModalOpen(false)
          setIsTextSelectedEn(false)
          setIsTextSelectedTe(false)
          setSelectedText('')
          setLink('')
        }}
        onSave={link => {
          setModalOpen(false)
          handleSaveLink(link)
          setSelectedText('')
          setIsTextSelectedEn(false)
          setIsTextSelectedTe(false)
          setLink('')
        }}
      />
    </div>
  )
}

export default ShortBioField
